export const environment = {
  production: true,
  testing: true,
  api_base: 'https://dev.exams.dm.cit.tum.de/api'
};
